import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Separator} from 'platform/components';
import {Center, Icon} from 'platform/foundation';
import styled from 'styled-components';

import {VehicleColumn, VehicleColumnProps} from './VehicleColumn';

export function SortableVehicleColumn(props: VehicleColumnProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.vehicle.sourcingVehicle.id,
  });
  const transformString = CSS.Transform.toString(transform);

  return (
    <>
      <SortableVehicleColumnWrapper
        ref={setNodeRef}
        $isDragging={isDragging}
        $transform={transformString}
        $transition={transition}
      >
        <Center>
          <DragHandle {...attributes} {...listeners}>
            <Icon size={4} value="action/drag_indicator" color="text.tertiary" />
          </DragHandle>
        </Center>
        <VehicleColumn {...props} />
      </SortableVehicleColumnWrapper>
      <Separator orientation="vertical" spacing={0} />
    </>
  );
}

const SortableVehicleColumnWrapper = styled.div<{
  $isDragging: boolean;
  $transform: string | undefined;
  $transition: string | undefined;
}>`
  width: ${({theme}) => theme.getSize(40)};
  flex-shrink: 0;
  background-color: ${({theme}) => theme.colors.general.white};
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0.5 : 1)};
  z-index: ${({$isDragging}) => ($isDragging ? 1 : 0)};
`;

const DragHandle = styled.div`
  cursor: grab;
  padding: ${({theme}) => theme.getSize(1)};
  border-radius: ${({theme}) => theme.radii.xSmall};
  &:hover {
    background-color: ${({theme}) => theme.colors.palettes.neutral['10']['100']};
  }
  &:active {
    cursor: grabbing;
  }
`;
